import { useSyncExternalStore } from 'react'

import screens from 'resources/screens'

const phoneLayoutQuery = `(max-width: ${screens.phone}px)`

const subscribe = (onChange: () => void) => {
  const mediaQueryList = window.matchMedia(phoneLayoutQuery)
  mediaQueryList.addEventListener('change', onChange)
  return () => mediaQueryList.removeEventListener('change', onChange)
}

const getSnapshot = () => window.matchMedia(phoneLayoutQuery).matches

const getServerSnapshot = () => false

export const useIsPhoneLayout = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
